import { Activity } from 'lucide-react';
import { useStaffDashboard } from '../hooks';
import { DataView } from '../../../components/ui/DataView';
import { StatusBadge } from '../../../components/ui/StatusBadge';
import type { PeriodOption } from '@repo/shared-dashboard';

interface AgentStatsWidgetProps {
  period?: PeriodOption;
}

export function AgentStatsWidget({ period = 'month' }: AgentStatsWidgetProps) {
  const query = useStaffDashboard(period);

  return (
    <DataView query={query} isEmpty={() => false}>
      {(data) => (
        <div className="bg-surface-1 rounded-[10px] p-5 flex items-center gap-4 relative overflow-hidden transition-colors hover:bg-surface-2/50 h-full shadow-sm">
          <div className="p-3 bg-warning-50 text-warning-500 rounded-[8px] border border-warning-200/50 flex-shrink-0">
            <Activity className="w-6 h-6" />
          </div>
          <div>
            <div className="font-semibold text-3xl sm:text-4xl tnum text-text-primary leading-none">
              {data?.agentsCount ?? 0}
            </div>
            <div className="text-xs font-medium text-text-secondary uppercase tracking-wider mt-1.5">Field Agents</div>
          </div>
          <div className="absolute right-3 top-3">
            <StatusBadge status="success" label="Active" />
          </div>
        </div>
      )}
    </DataView>
  );
}

